// LEER CON COPIA, SIN REACT · DIRECTRIZ-PWA F2 (11 oct 2026, DISENO-F2 §4.1).
//
// La misma regla que `useDatosDeTrabajo`, para los catálogos que una
// pantalla pide dentro de un efecto o de un modal (`/ubicaciones`,
// `/productos?limite=500`, `/configuracion/control`, `/ventas/configuracion`,
// `/traslados/{id}`). Devuelve `{datos, momento}`: `momento` es null si
// vino de la API y la hora de la copia si vino del teléfono. Quien pinta
// un dato de copia pinta su hora: por eso viajan juntos.
//
// NUNCA tapa un 401, 403 ni 404: la regla vive en `sirveLaCopia`
// (`cacheTrabajo.js`), con su porqué.
import { api } from '../api';
import { guardarTrabajo, leerTrabajo, sirveLaCopia } from './cacheTrabajo';

export async function leerConCopia(idUsuario, ruta, { recortar = (d) => d } = {}) {
  try {
    const datos = await api.get(ruta);
    // Después de tener el dato: guardar la copia no retrasa la pantalla y,
    // si falla, no cambia nada de lo que se ve. `guardarTrabajo` no lanza.
    guardarTrabajo(idUsuario, ruta, recortar(datos));
    return { datos, momento: null };
  } catch (e) {
    if (!sirveLaCopia(e)) throw e;
    const copia = await leerTrabajo(idUsuario, ruta);
    if (copia) return { datos: copia.datos, momento: copia.momento };
    throw e;
  }
}

/** La hora de una copia como la lee una persona: «9:12». */
export function horaDe(momento) {
  if (!momento) return '';
  return new Date(momento).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });
}
